import { format, isValid } from 'date-fns';

import { DateLike, toDate } from './date';

export type DateFormat = 'datetime-us' | 'date-us-short' | 'date-us-medium';

/**
 * Format a date like value into a user-facing string.
 * See https://atlassian.design/content/writing-guidelines/date-and-time-guideline
 *
 * Supported date/time formats:
 * - `datetime-us`: US style date with time. Example: "Dec 2 2022, 11:59"
 * - `date-us-medium`: US style date without time. Example: "December 2, 2022"
 * - `date-us-short`: US style date with short month. Example: "Dec 2, 2022"
 */
export function formatDate(
  date: DateLike,
  dateFormat: DateFormat = 'datetime-us'
): string {
  const dateObj = toDate(date);

  if (!isValid(dateObj)) {
    return 'Invalid Date';
  }

  switch (dateFormat) {
    case 'date-us-short':
      return format(dateObj, 'MMM dd, yyyy');
    case 'date-us-medium':
      return format(dateObj, 'MMMM dd, yyyy');
    default:
      // datetime-us
      return format(dateObj, 'MMM dd, yyyy HH:mm');
  }
}
